<template>
    <div>
        <div class="flowBox">
            <div class="firstBox">
                <div class="first">1</div>
                <p>上传文件与设置签署方</p>
            </div>
            <div style="margin: 0px 10px;color: #525961">——</div>
            <div class="secondBox">
                <div class="second">2</div>
                <p>设置签署与填写信息</p>
            </div>
            <div style="margin: 0px 10px;color: #525961">——</div>
            <div class="thirdBox">
                <div class="third">3</div>
                <p>保存模板</p>
            </div>
        </div>
        <div class="UploadBox">
            <div class="newsBox">
                <p>模板基本信息</p>
                <div class="Copies">
                    剩余合同份数: <span style="color: #1e57dc;font-weight: 500"> 25 </span>份
                </div>
            </div>
            <div class="upload">
                <el-upload
                        class="upload-demo"
                        drag
                        :limit="1"
                        accept=".pdf,.jpg,.png"
                        :before-upload="beforeAvatarUpload"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">请上传合同文件(加密文件请转成普通文件再上传)
                        <div class="el-upload__tip" slot="tip">最多上传1份文件,单份文件小于5M,支持.pdf,.jpg,.png</div>
                    </div>
                </el-upload>
            </div>
            <div class="templateNameBox">
                <div class="templateName">
                    <p>模板名称</p>
                    <el-input  v-model="name" placeholder="请输入模板名称"></el-input>
                </div>
                <div class="templateType" style="margin-left: 60px">
                    <p>模板类型</p>
                    <el-input  v-model="type"  placeholder="请输入模板类型"></el-input>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "InitiateTemplate",
        data(){
            return{
                name:'',
                type:''
            }
        },
        methods:{
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isLt2M) {
                    this.$message.error('上传文件大小不能超过 5MB!');
                }
                return isLt2M;
            }
        }
    }
</script>

<style scoped>

    .flowBox{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100px;
        background-color: #fff;
    }
    .firstBox,
    .secondBox,
    .thirdBox{
        display: flex;
        align-items: center;
    }
    .first{
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        line-height: 40px;
        color: #fff;
        width: 40px;
        height: 40px;
        background-color: #3e62f6;
        border-radius: 50%;
    }
    .firstBox>p{
        margin: 0px 10px;
    }
    .second,
    .third{
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color: #a8abb0;
        border-radius: 50%;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
    }
    .secondBox>p,
    .thirdBox>p{
        margin: 0px 10px;
        color: #b6b7bc;
    }
/*    上传信息*/
    .UploadBox{
        margin: 10px 0px;
        /*height: 300px;*/
        background-color: #fff;
    }
    .upload{
        margin: 0px 30px;
    }
    .newsBox{
        display: flex;
        margin: 0px 30px;
        padding: 20px 0px;
        align-items: center;
    }
    .newsBox>p{
        font-size: 18px;
        margin-right: 30px;
    }
    .Copies{
        color: #a8abb0;
    }
    /deep/.el-upload{
        width: 100%;
    }
    /deep/.el-upload-dragger{
        width: 100%;
    }
    /deep/.el-upload-dragger{
        border: 0px;
        width: 100%;
    }
    .templateNameBox{
        margin:0px 30px;
        padding: 20px 0px;
        display: flex;
    }
    .templateName,
    .templateType{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .templateName>p,
    .templateType>p{
        width: 120px;
    }

</style>
